import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from "@angular/core";
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";
import { MatButtonModule } from "@angular/material/button";
import { ConfirmationDialogComponent } from "@shared/components/dialog/confirmation-dialog/confirmation-dialog.component";
import { FormStateService } from "@core/services/form-state.service";
import { MatDialog } from "@angular/material/dialog";
import { PendingChangesDialogComponent } from "@shared/components/dialog/pending-changes/pending-changes-dialog.component";

@Component({
  selector: 'app-form-footer',
  standalone: true,
  templateUrl: './form-footer.component.html',
  styleUrl: './form-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideTranslationScope('shared/form-footer')
  ],
  imports: [
    MatButtonModule,
    TranslationPipeModule,
    ConfirmationDialogComponent
  ]
})
export class FormFooterComponent {
  protected readonly formStateService: FormStateService = inject(FormStateService);

  private readonly _dialog: MatDialog = inject(MatDialog);

  @Output() public readonly save: EventEmitter<void> = new EventEmitter<void>();

  @Output() public readonly discard: EventEmitter<void> = new EventEmitter<void>();

  protected onSaveClick (): void {
    this.save.emit();
  }

  protected onCancelClick (): void {
    if (this.formStateService.isDirty()) {
      this._dialog.open(PendingChangesDialogComponent)
        .afterClosed()
        .subscribe((confirmed: boolean): void => {
          if (confirmed)
            this.discard.emit();
        });
    }
  }
}
